export default __webpack_public_path__ + "static/media/clipboard-minus.9d4fc53c.svg";